module.exports = __webpack_public_path__ + "img/blog4.f613f16e.jpg";